var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6.75C6 5.7835 6.7835 5 7.75 5H10.25C10.6642 5 11 5.33579 11 5.75C11 6.16421 10.6642 6.5 10.25 6.5H7.75C7.61193 6.5 7.5 6.61193 7.5 6.75V17.25C7.5 17.3881 7.61193 17.5 7.75 17.5H10.25C10.6642 17.5 11 17.8358 11 18.25C11 18.6642 10.6642 19 10.25 19H7.75C6.7835 19 6 18.2165 6 17.25V6.75ZM16.4393 11.25H10.75C10.3358 11.25 10 11.5858 10 12C10 12.4142 10.3358 12.75 10.75 12.75H16.4393L14.4697 14.7197C14.1768 15.0126 14.1768 15.4874 14.4697 15.7803C14.7626 16.0732 15.2374 16.0732 15.5303 15.7803L18.7803 12.5303C19.0732 12.2374 19.0732 11.7626 18.7803 11.4697L15.5303 8.21967C15.2374 7.92678 14.7626 7.92678 14.4697 8.21967C14.1768 8.51256 14.1768 8.98744 14.4697 9.28033L16.4393 11.25Z",
    fill: "#B1D1FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.fb215af88fa1590c7e51d219e87881cf.svg";
export { ForwardRef as ReactComponent };